import { MallAxiosInterceptor } from "api/core/consts";

export const category = {
  getMallCategory: (mallCategoryId) => MallAxiosInterceptor.get('/mallCategory/' + mallCategoryId),
  searchMallCategory: (body) => MallAxiosInterceptor.post('/mallCategory/search', body),
  createMallCategory: (body) => MallAxiosInterceptor.post('/mallCategory', body),
  updateMallCategory: (mallCategoryId, body) => MallAxiosInterceptor.put('/mallCategory/' + mallCategoryId, body),
  deleteMallCategory: (mallCategoryId) => MallAxiosInterceptor.delete('/mallCategory/' + mallCategoryId),
};
